import { makeAutoObservable, runInAction } from "mobx";

export default class ModalWindows {
  guestModal = false;
  registrationModal = false;
  signInModal = false;
  checkPhoneModal = false;
  registrationSuccessModal = false;
  newPasswordModal = false;
  signInWithNewPasswordModal = false;

  educationalCenterModal = false;
  applicationSuccessModal = false;
  applicationSuccessModalFromVacancy = false;

  modalShowVacancies = false;
  modalShowCandidate = false;
  modalShowCenterDate = false;

  sendApplicationModal = false;

  deleteCandidateModal = false;

  addNewCandidateModal = false;

  fileUploadErrorModal = false;

  isCandidateModalOpen = false;

  deleteMessage = "";

  sendingFunc = null;

  constructor(instance) {
    this.rootStore = instance;
    makeAutoObservable(this, {}, { deep: true });
  }

  setGuestModal = (value) => {
    runInAction(() => (this.guestModal = value));
  };

  setRegistrationModal = (value) => {
    runInAction(() => (this.registrationModal = value));
  };

  setSignInModal = (value) => {
    runInAction(() => (this.signInModal = value));
  };

  setCheckPhoneModal = (value) => {
    runInAction(() => (this.checkPhoneModal = value));
  };

  setRegistrationSuccessModal = (value) => {
    runInAction(() => (this.registrationSuccessModal = value));
  };

  setNewPasswordModal = (value) => {
    runInAction(() => (this.newPasswordModal = value));
  };

  setSignInWithNewPasswordModal = (value) => {
    runInAction(() => (this.signInWithNewPasswordModal = value));
  };

  setEducationalCenterModal = (value) => {
    runInAction(() => (this.educationalCenterModal = value));
  };

  setApplicationSuccessModal = (value) => {
    runInAction(() => (this.applicationSuccessModal = value));
  };

  setApplicationSuccessModalFromVacancy = (value) => {
    runInAction(() => (this.applicationSuccessModalFromVacancy = value));
  };

  setModalShowVacancies = (value) => {
    runInAction(() => (this.modalShowVacancies = value));
  };

  setModalShowCandidate = (value) => {
    runInAction(() => (this.modalShowCandidate = value));
  };

  setModalShowCenterDate = (value) => {
    runInAction(() => (this.modalShowCenterDate = value));
  };

  setSendApplicationModal = (value) => {
    runInAction(() => (this.sendApplicationModal = value));
  };

  setDeleteCandidateModal = (value) => {
    runInAction(() => (this.deleteCandidateModal = value));
  };

  setAddNewCandidateModal = (value) => {
    runInAction(() => (this.addNewCandidateModal = value));
  };

  setFileUploadErrorModal = (value) => {
    runInAction(() => (this.fileUploadErrorModal = value));
  };

  setIsCandidateModalOpen = (value) => {
    runInAction(() => (this.isCandidateModalOpen = value));
  };

  setDeleteModalMessage = (value) => {
    runInAction(() => (this.deleteMessage = value));
  };

  setFunc = (func) => {
    runInAction(() => (this.sendingFunc = func));
  };
}
